import { QueryClient } from '@tanstack/react-query'
import { hoursToMilliseconds, secondsToMilliseconds } from 'date-fns'

export const _createQueryClient = () => {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // How long an unused query survives in memory. Long, because evicting it only
        // costs a refetch on the way back — it never serves stale data, `staleTime`
        // decides that.
        gcTime: hoursToMilliseconds(24),
        refetchOnWindowFocus: false,
        // The freshness window every query inherits unless it says otherwise. Much of
        // what this app shows changes behind the user's back — a background job finishing,
        // a webhook landing — and with focus refetching off, this is the only thing that
        // brings those in without an explicit invalidation.
        staleTime: secondsToMilliseconds(30),
      },
    },
  })
}

let queryClient: QueryClient

export const createQueryClient = () => {
  if (queryClient) return queryClient
  queryClient = _createQueryClient()

  return queryClient
}
